<template>
  <el-container style="background: #fff; width: 100%; border: 1px solid #eee">
    <el-container>
      <el-header class="middle-header">
        <div style="padding: 10px 0">
          <el-input
            size="small"
            style="max-width: 236px"
            clearable
            @clear="clear"
            :placeholder="searchPlaceholder"
            prefix-icon="el-icon-search"
            @keyup.enter.native="search"
            v-model="searchWord"
          ></el-input>
          <el-select v-model="selectWord" placeholder="状态" style="max-width: 80px; margin-left: 20px" v-if="userSelect">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <el-button style="margin-left: 20px" size="small" type="primary" icon="el-icon-search" @click="search" :disabled="loading">搜索</el-button>
          <el-button size="small" :disabled="loading" @click="reset" icon="el-icon-refresh">清空</el-button>
        </div>
      </el-header>
      <el-main style="padding: 0">
        <el-table
          :data="data"
          v-loading="loading"
          ref="selectorTable"
          stripe
          border
          height="490"
          :highlight-current-row="single"
          @row-click="handleRowClick"
          @select="handleTableSelect"
          @select-all="handleTableSelect"
          class="selector-table"
          size="small"
        >
          <el-table-column type="selection" align="center" width="45" v-if="!this.single"></el-table-column>
          <el-table-column align="center" width="50" v-if="this.single">
            <template slot-scope="scope">
              <el-radio v-model="selectedId" :label="scope.row[this.unique]"></el-radio>
            </template>
          </el-table-column>
          <eco-table-column
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            v-for="(column, index) in tableColumns"
            :key="index"
            :formatter="column.prop === 'f_cm_measurement_unit' ? attrFormat : null"
          >
            <template slot-scope="scope">
              <div class="cell" v-if="column.type == 'timestamp'">
                {{ scope.row[column.prop] | dateformat('YYYY-MM-DD HH:mm:ss') }}
              </div>
              <div class="cell" v-else>{{ scope.row[column.prop] }}</div>
            </template>
          </eco-table-column>
        </el-table>
      </el-main>
      <el-footer class="pagination-class" height="50px" v-if="isShowPagenation">
        <el-row type="flex" justify="end">
          <el-pagination
            small
            :disabled="loading"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 50, 100, 200, 300]"
            :page-size="pagination.pageSize"
            :pager-count="5"
            layout="total, sizes, prev, pager, next ,jumper"
            :total="pagination.total"
          ></el-pagination>
        </el-row>
      </el-footer>
    </el-container>
    <el-aside width="80px" class="right-aside" v-if="!this.single">
      <div class="button-group">
        <el-button size="small" @click="move('up')">上移</el-button>
        <el-button size="small" @click="move('down')">下移</el-button>
        <el-button size="small" @click="removeSelected">删除</el-button>
        <el-button size="small" @click="clearAllSelects">清空</el-button>
      </div>
    </el-aside>
    <el-aside width="170px" class="select-aside" v-if="!this.single">
      <el-header class="select-header">
        <span style="font-size: 14px">已选择</span>
      </el-header>
      <div class="select-tree-div">
        <el-tree small ref="selectTree" :node-key="this.unique" :props="treeProps" :data="selects" show-checkbox check-on-click-node></el-tree>
      </div>
    </el-aside>
  </el-container>
</template>
<script>
import utils from '@/eco-ui-util.js'

export default {
  name: 'eco-selector',
  props: {
    unique: {
      type: String,
      default: 'id'
    },
    userSelect: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: 'f_cm_name'
    },
    tableColumns: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: Array,
    single: {
      type: Boolean,
      default: false
    },
    //服务端分页
    pagination: {
      type: Object,
      default: () => {
        return {
          page: 1,
          pageSize: 50,
          total: 31214,
          showTotal: true
        }
      }
    },
    quickSearchProps: {
      type: [String, Array],
      required: true
    },
    selectSearchProps: {
      type: [String, Array],
      required: true
    },
    isShowPagenation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [
        {
          value: 2,
          label: '全部'
        },
        {
          value: 1,
          label: '在职'
        },
        {
          value: -2,
          label: '离职'
        }
      ],
      attrDicData: [],
      loading: false,
      searchWord: null,
      selectWord: 1,
      //客户端分页
      paging: {
        page: 1,
        pageSize: 50
      },
      selectedId: null,
      selects: []
    }
  },
  computed: {
    treeProps: function () {
      return { label: this.selectLabel }
    }
  },
  watch: {
    data: function (newVal) {
      if (newVal && newVal.length > 0) {
        this.syncCheckedStatus()
      }
    }
  },
  created() {
    // 组件初始化时，复制一份分页信息
    this.oldPaging = { ...this.paging }
    this.attrDicData = []
    this.$http.post('${portal}/sys/dataDict/v1/getByTypeKeyForComBo?typeKey=gdzcjldw').then((resp) => {
      if (resp.data && resp.data.length > 0) {
        resp.data.forEach((ele) => {
          const obj = {
            value: ele.name,
            key: ele.key
          }
          this.attrDicData.push(obj)
        })
      }
    })
  },
  methods: {
    attrFormat(row) {
      if (this.attrDicData && this.attrDicData.length > 0) {
        return this.attrDicData.map((item) => {
          if (row.f_cm_measurement_unit == item.key) {
            return item.value
          }
        })
      }
    },
    // 同步已选行到已选数据中去
    syncSelection2selects() {
      // 复制一份当前已选数据
      let tmpSelects = [...this.selects]
      // 先将当前页中的数据从已选数据中移除
      this.data.forEach((m) => {
        tmpSelects.forEach((n) => {
          if (m[this.unique] === n[this.unique]) {
            tmpSelects.remove(m)
          } else if (utils.objectEquals(m, n)) {
            tmpSelects.remove(m)
          }
        })
      })
      // 将剩余的已选数据与当前页选中的数据合并
      tmpSelects = [...tmpSelects, ...this.$refs.selectorTable.selection]
      // 数组去重
      this.selects = tmpSelects.unique(this.unique)
    },
    // 同步已选数据在Table中的选中状态
    syncCheckedStatus() {
      this.selectedId = null
      if (this.single) {
        this.selects.length === 1 && (this.selectedId = this.selects[0][this.unique])
      } else {
        if (!this.$refs.selectorTable || !this.$refs.selectorTable.selection) {
          throw '未获取到数据列表，无法选择数据。'
        }
        this.$refs.selectorTable.clearSelection()
        this.selects.length > 0 &&
          setTimeout(() => {
            this.data.forEach((n) => {
              this.selects.forEach((m) => {
                if (n[this.unique] === m[this.unique]) {
                  this.$refs.selectorTable.toggleRowSelection(n)
                } else if (utils.objectEquals(m, n)) {
                  this.$refs.selectorTable.toggleRowSelection(n)
                }
              })
            })
          })
      }
    },
    onShow(initSelectors) {
      // 每一次显示选择器时，重置当前选中数据为外部的v-model对象
      if (!initSelectors) {
        this.selects = [...this.value]
      } else {
        this.selects = initSelectors
      }

      this.reset()
    },
    onHide(sure) {
      // 在隐藏选择器时，如果点击的是确定按钮，则将当前选中数据更新到外部的v-model对象上
      if (sure) {
        this.$emit('input', this.selects)
      }
    },
    getQueryFilter() {
      let queryFilter = {
        querys: [],
        pageBean: this.paging
      }

      if (this.quickSearchProps && this.quickSearchProps.constructor == String && this.searchWord) {
        //有搜索条件时重置分页
        // queryFilter.pageBean.page = 1;
        let props = this.quickSearchProps.split(',')
        props.forEach((item) => {
          let query = {
            property: item,
            value: this.searchWord,
            group: 'main',
            operation: 'LIKE',
            relation: 'OR'
          }
          queryFilter.querys.push(query)
        })
      }
      if (this.selectSearchProps && this.selectSearchProps.constructor == String && this.selectWord != 2) {
        //有搜索条件时重置分页
        // queryFilter.pageBean.page = 1;
        queryFilter.querys.push({
          property: this.selectSearchProps,
          value: this.selectWord,
          group: 'advanced',
          operation: 'EQUAL',
          relation: 'AND'
        })
      }
      return queryFilter
    },
    // 加载数据，根据当前的搜索关键词及分页条件
    load() {
      this.loading = true

      this.$emit('load', this.getQueryFilter(), () => {
        this.loading = false
      })
    },
    // 搜索事件
    search() {
      if (this.loading) {
        return
      }
      this.paging = this.oldPaging
      this.paging.page = 1
      this.load()
    },
    // 重置事件
    reset() {
      this.$emit('reset')
      this.searchWord = null
      this.paging = this.oldPaging
      this.load()
    },
    clear() {
      this.reset()
    },
    handleRowClick(row, column, event) {
      if (this.single) {
        this.selects = [row]
        this.selectedId = row[this.unique]
      } else {
        if (!this.$refs.selectorTable || !this.$refs.selectorTable.selection) {
          throw '未获取到数据列表，无法选择数据。'
        }
        let _tag = true
        this.$refs.selectorTable.selection.forEach((m) => {
          if (m === row) {
            // 已选中该行时，取消选中状态
            this.$refs.selectorTable.toggleRowSelection(row, false)
            _tag = false
          }
        })
        // 非取消选中情况下，将当前行设置为选中状态
        _tag && this.$refs.selectorTable.toggleRowSelection(row)
        this.syncSelection2selects()
      }
    },
    handleTableSelect() {
      this.syncSelection2selects()
    },
    handleSizeChange(size) {
      this.paging.pageSize = size
      this.load()
    },
    handleCurrentChange(currentPage) {
      this.paging.page = currentPage
      this.load()
    },
    move(direct) {
      let selectedAry = this.$refs.selectTree.getCheckedNodes()
      // 将调整顺序之后的数组赋值给Tree
      this.selects = utils.arrayMove(this.selects, selectedAry, direct)
      setTimeout(() => {
        // 调整顺序后恢复勾选状态
        this.$refs.selectTree.setCheckedNodes(selectedAry)
      })
    },
    removeSelected() {
      let selectedAry = this.$refs.selectTree.getCheckedNodes()
      selectedAry.forEach((item) => {
        this.selects.remove(item)
      })
      this.syncCheckedStatus()
    },
    clearAllSelects() {
      this.selects = []
      this.syncCheckedStatus()
    }
  }
}
</script>
<style lang="stylus" scoped>
.middle-header {
  height: 52px !important;
}

.selector-table {
  width: 100%;
}

.right-aside {
  border-left: 1px solid #eee;
}

.select-aside {
  border-left: 1px solid #eee;
}

.select-header {
  border-bottom: 1px solid #eee;
  height: 52px !important;
}

.select-header > span {
  padding: 10px 0;
  line-height: 53px;
}

.select-tree-div {
  height: 500px;
  overflow-y: auto;
}

.button-group {
  width: 60px;
  height: 170px;
  margin: 0px auto;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}

.button-group > button {
  display: block;
  margin: 8px 0;
}

>>> .el-footer {
  padding: 10px 20px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-negative: 0;
  flex-shrink: 0;
}

>>> .el-tree__empty-text {
  font-size: 13px;
}

>>> .el-pagination__sizes {
  margin-top: -2px;
}

>>> span.el-radio__label {
  display: none;
}

.pagination-class >>> {
  padding: 10px;
}

.pagination-class >>> .el-pagination__total{
  margin-right: 5px;
}

.pagination-class >>> .el-pagination__sizes{
  margin-right: 5px;
}

.pagination-class >>> .el-pagination__jump{
    margin-left: 10px;
}
</style>
